import { Component, inject, Input } from '@angular/core';
import { DropdownComponent } from '../../ui/dropdown/dropdown.component';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { DropdownItemTwoComponent } from '../../ui/dropdown/dropdown-item/dropdown-item.component-two';
import { AuthService } from '../../../../services/auth/auth.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ToastModule } from 'primeng/toast';

@Component({
  standalone: true,
  selector: 'app-user-dropdown',
  templateUrl: './user-dropdown.component.html',
  imports: [CommonModule, RouterModule, DropdownComponent, DropdownItemTwoComponent, ConfirmDialogModule, ToastModule],
  providers: [ConfirmationService, MessageService]
})
export class UserDropdownComponent {
  isOpen = false;
  private authService = inject(AuthService);
  private confirmationService = inject(ConfirmationService);
  private messageService = inject(MessageService);
  @Input() userDetails: any;
  @Input() firstName: string = '';
  @Input() lastName: string = '';
  @Input() email: string = '';
  @Input() profileImageUrl: string = '';

  //Compute initials from firstName and lastName
  getInitials(): string {
    const first = this.firstName?.trim()?.charAt(0)?.toUpperCase() || '';
    const last = this.lastName?.trim()?.charAt(0)?.toUpperCase() || '';
    return `${first}${last}` || '?';
  }

  toggleDropdown() {
    this.isOpen = !this.isOpen;
  }

  closeDropdown() {
    this.isOpen = false;
  }

  signOutUser() {
    this.confirmationService.confirm({
      message: 'Are you sure you want to logout?',
      header: 'Logout Confirmation',
      icon: 'pi pi-info-circle',
      rejectLabel: 'Cancel',
      rejectButtonProps: {
        label: 'Cancel',
        severity: 'secondary',
        outlined: true
      },
      acceptButtonProps: {
        label: 'Logout',
        severity: 'danger'
      },

      accept: () => {
        localStorage.removeItem('msal.interaction.status');
        sessionStorage.removeItem('msal.interaction.status');
        this.authService.singOut();
        this.messageService.add({ severity: 'info', summary: 'Confirmed', life: 4000, detail: 'You have logged out' });
      },
      reject: () => {

      }
    });

  }
}